(() => {
  const init = (root) => {
    if (root.dataset.bscReady) return;
    root.dataset.bscReady = '1';
    const chips = root.querySelectorAll('[data-bsc-filter]');
    const studies = root.querySelectorAll('[data-bsc-group]');

    const filter = (group) => {
      chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.bscFilter === group)));
      studies.forEach((study) => {
        study.hidden = group !== '' && study.dataset.bscGroup !== group;
      });
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        filter(chip.dataset.bscFilter);
        const list = root.querySelector('.bsc__list');
        if (list && list.getBoundingClientRect().top < 0) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-bsc-copy]').forEach((button) => {
      const label = button.querySelector('span');
      const idle = label.textContent;
      button.addEventListener('click', async () => {
        const text = button.dataset.bscCopy;
        try {
          await navigator.clipboard.writeText(text);
        } catch (e) {
          const area = document.createElement('textarea');
          area.value = text;
          area.setAttribute('readonly', '');
          area.style.cssText = 'position:fixed;opacity:0';
          document.body.appendChild(area);
          area.select();
          document.execCommand('copy');
          area.remove();
        }
        label.textContent = button.dataset.bscDone;
        button.classList.add('is-done');
        clearTimeout(button._bscTimer);
        button._bscTimer = setTimeout(() => {
          label.textContent = idle;
          button.classList.remove('is-done');
        }, 1800);
      });
    });

    const showTarget = () => {
      const id = decodeURIComponent(location.hash.slice(1));
      if (id.indexOf('ingredient-') === 0) {
        const want = id.slice(11);
        const chip = [...chips].find((c) => c.dataset.bscFilter && (c.dataset.bscFilter === want || c.dataset.bscFilter.indexOf(want) === 0));
        if (chip) {
          filter(chip.dataset.bscFilter);
          const bar = root.querySelector('.bsc__filters');
          requestAnimationFrame(() => (bar || root).scrollIntoView({ block: 'start' }));
        }
        return;
      }
      const target = id && root.querySelector(`[id="${CSS.escape(id)}"]`);
      if (!target) return;
      if (target.hidden) filter('');
      target.classList.remove('is-target');
      void target.offsetWidth;
      target.classList.add('is-target');
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    };
    window.addEventListener('hashchange', showTarget);
    showTarget();
  };

  const run = () => document.querySelectorAll('[data-bsc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
